<template>
  <div>
    <v-card>
      <v-card-title class="text_primary pb-4">
        導覽管理
        <v-spacer></v-spacer>
        <v-btn
          color="deep-orange"
          dark
          class="mr-2"
          @click="openStyleDialog"
        >
          <v-icon left>mdi-palette</v-icon>
          樣式設定
        </v-btn>
        <v-btn
          class="btn_action btn_action_bg_linear"
          @click="createGuide"
        >
          <v-icon left>mdi-plus</v-icon>
          新增導覽
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-data-table
        :headers="headers"
        :items="items"
        hide-default-footer
      >
        <template v-slot:[`item.active`]="{ item }">
          <div class="d-flex align-center" style="height: 100%;">
            <v-switch
              v-model="item.active"
              dense
              hide-details
              class="mt-0 pt-0"
              @change="toggleActive(item)"
            ></v-switch>
          </div>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex gap align-center">
            <v-btn
              class="text_default btn_default btn_default_bg_linear"
              outlined
              @click="editGuide(item)"
              v-text="'編輯'"
            />
            <v-btn
              color="error"
              @click="openDeleteDialog(item)"
              v-text="'刪除'"
            />
          </div>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="style_dialog.show" max-width="400" @click:outside="closeStyleDialog">
      <v-card>
        <v-card-title class="font-weight-bold">樣式設定</v-card-title>
        <v-card-text class="pb-0">
          <div
            v-for="field in style_fields"
            :key="field.key"
            class="d-flex align-center mb-4"
          >
            <span class="body-2 flex-grow-1">{{ field.label }}</span>
            <v-text-field
              v-model="style_dialog.config[field.key]"
              dense
              outlined
              hide-details
              class="style-dialog__hex-input mr-3"
            ></v-text-field>
            <v-menu
              v-model="style_dialog.menu[field.key]"
              :close-on-content-click="false"
              offset-y
              left
            >
              <template v-slot:activator="{ on }">
                <div
                  class="style-dialog__color-preview"
                  :style="{ background: style_dialog.config[field.key] }"
                  v-on="on"
                ></div>
              </template>
              <v-color-picker
                v-model="style_dialog.config[field.key]"
                mode="hexa"
                flat
              ></v-color-picker>
            </v-menu>
          </div>
        </v-card-text>
        <v-card-actions class="justify-end gap pa-4 pt-0">
          <v-btn class="grey white--text" v-text="'取消'" @click="closeStyleDialog" />
          <v-btn class="btn_action btn_action_bg_linear" :loading="style_dialog.loading" v-text="'儲存'" @click="saveStyle" />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="delete_dialog.show" max-width="400" @click:outside="closeDeleteDialog">
      <v-card>
        <v-card-title class="justify-center font-weight-bold" v-text="'確認刪除'" />
        <v-card-subtitle class="text-center mt-1">
          確定要刪除導覽「{{ delete_dialog.target && delete_dialog.target.name }}」嗎？此動作無法復原。
        </v-card-subtitle>
        <v-card-actions class="justify-end gap pa-4 pt-0">
          <v-btn class="grey white--text" v-text="'取消'" @click="closeDeleteDialog" />
          <v-btn class="error" :loading="delete_dialog.loading" v-text="'刪除'" @click="confirmDelete" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {apiGetGuides, apiUpdateGuide} from "@/api/guide";

const DEFAULT_CONFIG = {
  bg_color: '#FDE047FF',
  text_color: '#000000FF',
  btn_bg_color: '#000000FF',
  btn_text_color: '#FFFFFFFF',
}

export default {
  name: 'GuideList',
  data () {
    return {
      guides_raw_data: null, // 因為此功能只有一支 api 的一個欄位可以用，欄位是存 json，一次更新需要整包的資料
      headers: [
        { text: 'ID', value: 'id', sortable: false },
        { text: '名稱', value: 'name', sortable: false },
        { text: '啟用', value: 'active', sortable: false },
        { text: '', value: 'actions', sortable: false },
      ],
      items: [],
      style_fields: [
        { key: 'bg_color', label: '背景色' },
        { key: 'text_color', label: '文字顏色' },
        { key: 'btn_bg_color', label: '按鈕背景色' },
        { key: 'btn_text_color', label: '按鈕文字顏色' },
      ],
      style_dialog: {
        show: false,
        loading: false,
        config: { ...DEFAULT_CONFIG },
        menu: { bg_color: false, text_color: false, btn_bg_color: false, btn_text_color: false },
      },
      delete_dialog: {
        show: false,
        target: null,
        loading: false,
      },
    }
  },
  created () {
    this.getData()
  },
  methods: {
    openStyleDialog () {
      const saved = this.guides_raw_data?.setting?.config
      this.style_dialog.config = saved ? { ...saved } : { ...DEFAULT_CONFIG }
      this.style_dialog.show = true
    },
    closeStyleDialog () {
      this.style_dialog.show = false
    },
    createGuide () {
      this.$router.push('/setting/guide/new')
    },
    editGuide (item) {
      this.$router.push(`/setting/guide/${item.id}`)
    },
    openDeleteDialog (item) {
      this.delete_dialog.target = item
      this.delete_dialog.show = true
    },
    closeDeleteDialog () {
      this.delete_dialog.target = null
      this.delete_dialog.show = false
    },

    // API
    async saveStyle () {
      try {
        this.style_dialog.loading = true
        this.guides_raw_data.setting.config = { ...this.style_dialog.config }
        await apiUpdateGuide(this.guides_raw_data)
        this.$root.vtoast.show({ message: '儲存成功', color: 'primary' })
        this.closeStyleDialog()
      } catch (error) {
        console.error('saveStyle() :', error)
        this.$root.vtoast.show({ message: '儲存失敗', color: 'error' })
      }
      this.style_dialog.loading = false
    },
    async getData () {
      try {
        const res = await apiGetGuides()
        if (!res) return
        this.guides_raw_data = res
        this.items = this.guides_raw_data.setting.data
      } catch (error) {
        console.error('getData() :', error)
        this.$root.vtoast.show({ message: '取得資料失敗', color: 'error' })
      }
    },
    async toggleActive (item) {
      try {
        this.guides_raw_data.setting.data.forEach(guide => {
          if (guide.id === item.id) {
            guide.active = item.active
          }
        })
        await apiUpdateGuide(this.guides_raw_data)
      } catch (error) {
        console.error('toggleActive() :', error)
        this.$root.vtoast.show({ message: '編輯失敗', color: 'error' })
      }
    },
    async confirmDelete () {
      try {
        this.delete_dialog.loading = true
        this.guides_raw_data.setting.data = this.guides_raw_data.setting.data.filter(guide => guide.id !== this.delete_dialog.target.id)
        await apiUpdateGuide(this.guides_raw_data)
        await this.getData()
        this.$root.vtoast.show({ message: '刪除成功', color: 'primary' })
        this.delete_dialog.loading = false
        this.closeDeleteDialog()
      } catch (error) {
        console.error('confirmDelete() :', error)
        this.$root.vtoast.show({ message: '刪除失敗', color: 'error' })
      }
    },
  },
}
</script>

<style scoped>
.style-dialog__hex-input {
  max-width: 120px;
}

.style-dialog__color-preview {
  width: 36px;
  height: 36px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  cursor: pointer;
  flex-shrink: 0;
}
</style>
